import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HomeService } from 'src/app/service/common/home.service';

@Component({
  selector: 'app-diary-modal',
  templateUrl: './diary-modal.component.html',
  styleUrls: ['./diary-modal.component.css']
})
export class DiaryModalComponent implements OnInit {

  private _subs : Subscription = new Subscription();
  diaryData : any;

  constructor(
    private router : Router,
    private homeService : HomeService,
    private dialogRef : MatDialogRef<DiaryModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data : any
  ) { 
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this._subs.add(
      this.homeService.getCountDetails(this.data.type, this.data.barristerId).subscribe(res => {
        // console.log(res);
        if(res.status == 'ok'){
          this.diaryData = res.data;
        }else{
          this.dialogRef.close(null);
        }
      })
    )

  }

  ngOnDestroy(){ 
    this._subs.unsubscribe();
  }


  routeToCase(id){
    this.closeModal();
    this.router.navigateByUrl("/pages/cases/view/"+id);
  }

  closeModal(){
    this.dialogRef.close(null);
  }

  getPaymentBadgeClass(diary: any): string {
    if (!diary.advancePayment || !diary.advancePayment.trim()) {
      return 'badge-danger'; // Red when no payment
    }

    // Extract amount from advancePayment (e.g., "£5000 Paid" -> 5000)
    const amountMatch = diary.advancePayment.match(/£?(\d+(?:,\d{3})*(?:\.\d{2})?)/);
    const paidAmount = amountMatch ? parseFloat(amountMatch[1].replace(/,/g, '')) : 0;

    if (diary.advancePayment.toLowerCase().includes('paid')) {
      // Check if paid amount equals total fee
      if (diary.totalFee && paidAmount >= diary.totalFee) {
        return 'badge-success'; // Green when fully paid
      } else {
        return 'badge-warning'; // Yellow when partially paid even with "paid" status
      }
    }

    return 'badge-warning'; // Yellow when partial payment without "paid" status
  }

  getCourtListingBadgeClass(diary: any): string {
    if (diary.statusText && (diary.statusText.toLowerCase().includes('completed') || diary.statusText.toLowerCase().includes('confirmed') || diary.statusText.toLowerCase().includes('scheduled'))) {
      return 'badge-success'; // Green when completed/confirmed/scheduled
    }
    return 'badge-danger'; // Red when not completed
  }

  getCourtPaperBadgeClass(diary: any): string {
    if (diary.statusText && (diary.statusText.toLowerCase().includes('completed') || diary.statusText.toLowerCase().includes('confirmed') || diary.statusText.toLowerCase().includes('scheduled') || diary.statusText.toLowerCase().includes('ready'))) {
      return 'badge-success'; // Green when completed/confirmed/scheduled/ready
    }
    return 'badge-danger'; // Red when not completed
  }

  getAttendanceBadgeClass(diary: any): string {
    if (diary.statusText && (diary.statusText.toLowerCase().includes('completed') || diary.statusText.toLowerCase().includes('confirmed') || diary.statusText.toLowerCase().includes('scheduled'))) {
      return 'badge-success'; // Green when completed/confirmed/scheduled
    }
    return 'badge-danger'; // Red when not completed
  }

  getPaymentBadgeText(diary: any): string {
    return 'Payment';
  }

  getCourtListingBadgeText(diary: any): string {
    return 'Court Listing';
  }

  getCourtPaperBadgeText(diary: any): string {
    return 'Court Paper';
  }

  getAttendanceBadgeText(diary: any): string {
    return 'Attendance Note';
  }

  togglePaymentStatus(diary: any): void {
    if (diary.advancePayment && diary.advancePayment.toLowerCase().includes('paid')) {
      // Remove "paid" to make it due
      diary.advancePayment = diary.advancePayment.replace(/paid/i, '').trim();
    } else {
      // Add "paid" to make it confirmed
      diary.advancePayment = diary.advancePayment ? diary.advancePayment + ' Paid' : 'Paid';
    }
  }

  toggleStatusConfirmation(diary: any): void {
    if (diary.statusText && diary.statusText.toLowerCase().includes('confirmed')) {
      // Remove confirmation
      diary.statusText = diary.statusText.replace(/confirmed/i, '').trim();
    } else {
      // Add confirmation
      diary.statusText = diary.statusText ? diary.statusText + ' Confirmed' : 'Confirmed';
    }
  }

  toggleDocumentStatus(diary: any, docIndex: number): void {
    if (diary.additionalDocuments && diary.additionalDocuments[docIndex]) {
      diary.additionalDocuments[docIndex].submitted = !diary.additionalDocuments[docIndex].submitted;
    }
  }

  isAllConfirmed(diary: any): boolean {
    // Check if court listing is completed/confirmed/scheduled
    const courtListingConfirmed = diary.statusText && (
      diary.statusText.toLowerCase().includes('completed') ||
      diary.statusText.toLowerCase().includes('confirmed') ||
      diary.statusText.toLowerCase().includes('scheduled')
    );

    // Check if court paper is completed/confirmed/scheduled/ready
    const courtPaperConfirmed = diary.statusText && (
      diary.statusText.toLowerCase().includes('completed') ||
      diary.statusText.toLowerCase().includes('confirmed') ||
      diary.statusText.toLowerCase().includes('scheduled') ||
      diary.statusText.toLowerCase().includes('ready')
    );

    // Check if attendance is completed/confirmed/scheduled
    const attendanceConfirmed = diary.statusText && (
      diary.statusText.toLowerCase().includes('completed') ||
      diary.statusText.toLowerCase().includes('confirmed') ||
      diary.statusText.toLowerCase().includes('scheduled')
    );

    // Check if all additional documents are submitted
    const allDocumentsSubmitted = !diary.additionalDocuments ||
      diary.additionalDocuments.every((doc: any) => doc.submitted);

    return courtListingConfirmed && courtPaperConfirmed && attendanceConfirmed && allDocumentsSubmitted;
  }
}
